import type { PlotInfo } from "../net/api";

export interface PlotLocal { id: string; x: number; y: number; z: number }

/** Where the feet are in a plot's own coordinates, as put_layout's pos (spec 2l §4.1); null off every plot. */
export function plotLocal(x: number, feetY: number, z: number, plots: readonly PlotInfo[], height: (x: number, z: number) => number): PlotLocal | null {
  for (const p of plots) {
    const [x0, z0] = p.bounds.min, [x1, z1] = p.bounds.max;
    if (x >= x0 && x < x1 && z >= z0 && z < z1) return { id: p.id, x: x - x0, y: feetY - height(x, z), z: z - z0 };
  }
  return null;
}

const one = (v: number) => (Math.abs(v) < 0.05 ? 0 : v).toFixed(1);

/** The HUD's second line: "領地 block-0-n2　10.2, 0.0, 5.3", or "" off plot. */
export function plotLine(l: PlotLocal | null): string {
  return l ? `領地 ${l.id}　${one(l.x)}, ${one(l.y)}, ${one(l.z)}` : "";
}
